import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, FormItem, InlineNotification, TextInput } from '@carbon/react';
import DndUploader from 'src/components/Uploader/DNDUploader';
import { useAuthActions } from 'src/hooks/useAuthActions';
import { useAuthSession } from 'src/hooks/useAuthSession';
import { authClient } from 'src/services/auth/client';

const Profile = () => {
  const { t } = useTranslation();
  const { user } = useAuthSession();
  const { requestPasswordReset } = useAuthActions();
  const [name, setName] = useState('');
  const [image, setImage] = useState('');
  const [saved, setSaved] = useState(false);

  // Seeded during render rather than in an effect: the effect committed an empty field
  // first and replaced it on the next pass.
  const [seededName, setSeededName] = useState(user?.name ?? '');
  if ((user?.name ?? '') !== seededName) {
    setSeededName(user?.name ?? '');
    setName(user?.name ?? '');
  }

  async function onSubmit(event: React.FormEvent) {
    event.preventDefault();
    await authClient.updateUser({ name, image: image || undefined });
    setSaved(true);
  }

  return (
    <Form onSubmit={onSubmit} className="cds--profile">
      <h1>{t('profile.title')}</h1>
      {saved && <InlineNotification kind="success" title={t('profile.saved')} lowContrast hideCloseButton />}
      <TextInput
        id="profile-name"
        labelText={t('profile.name')}
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <TextInput id="profile-email" labelText={t('profile.email')} value={user?.email ?? ''} readOnly />
      <FormItem>
        <p className="cds--file--label">{t('profile.avatar')}</p>
        <DndUploader
          useCropper
          initialValue={null}
          cropperAspectRatio={1}
          previewAspectRatio="1x1"
          onChange={({ fileId }) => setImage(fileId)}
        />
      </FormItem>
      <Button type="submit">{t('profile.save')}</Button>
      {/* Password changes go through the same emailed-token flow as a reset — the portal
          never handles the old password, because the auth service owns credentials. */}
      <Button kind="tertiary" onClick={() => user?.email && requestPasswordReset(user.email)}>
        {t('profile.changePassword')}
      </Button>
    </Form>
  );
};

export default Profile;
